'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Compute = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = compute;

var _tags = require('./tags');

var _functionTree = require('function-tree');

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Compute = exports.Compute = function (_ResolveValue) {
  _inherits(Compute, _ResolveValue);

  function Compute(args) {
    _classCallCheck(this, Compute);

    var _this = _possibleConstructorReturn(this, (Compute.__proto__ || Object.getPrototypeOf(Compute)).call(this));

    _this.args = args;
    _this.value = null;
    return _this;
  }

  _createClass(Compute, [{
    key: 'getValue',
    value: function getValue(context) {
      var computeGet = function computeGet(tag) {
        return tag.getValue(context);
      };
      var result = this.args.reduce(function (details, arg, index) {
        if (arg instanceof _tags.Tag) {
          var path = arg.getPath(context);

          if (path.indexOf('.*') > 0) {
            var value = arg.getValue(context);

            details.results.push(value ? Object.keys(value) : []);
          } else {
            details.results.push(arg.getValue(context));
          }

          return details;
        } else if (arg instanceof _functionTree.ResolveValue) {
          details.results.push(arg.getValue(context));

          return details;
        } else if (typeof arg === 'function') {
          details.results.push(arg.apply(undefined, _toConsumableArray(details.results.slice(details.previousFuncIndex, index)).concat([computeGet])));
          details.previousFuncIndex = index;

          return details;
        }

        details.results.push(arg);

        return details;
      }, {
        results: [],
        previousFuncIndex: 0
      });

      return result.results[result.results.length - 1];
    }
  }]);

  return Compute;
}(_functionTree.ResolveValue);

function compute() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return new Compute(args);
}
//# sourceMappingURL=Compute.js.map


//////////////////
// WEBPACK FOOTER
// ./~/cerebral/lib/Compute.js
// module id = 242
// module chunks = 0